import React, { Component } from 'react';
import DayPicker, { DayModifiers } from 'react-day-picker';

import styles from './styles.less';

export type DisabledDays = {
	before?: Date;
	after?: Date;
};

interface Props {
	value: Date | null;
	disabledDays?: DisabledDays;
	onSelect(selectedDate: Date): void;
}

export default class DatePicker extends Component<Props> {
	static defaultProps = {
		value: null,
		disabledDays: null,
	};

	handleDayClick = (date: Date, modifiers: DayModifiers) => {
		if (modifiers[styles.disabled] === undefined) {
			this.props.onSelect(date);
		}
	};

	render() {
		const { value, disabledDays } = this.props;
		const now = new Date();

		return (
			// @ts-expect-error: wrong typing in DayPicker
			<DayPicker
				showOutsideDays
				classNames={styles}
				disabledDays={disabledDays}
				firstDayOfWeek={1}
				month={value === null ? now : value}
				selectedDays={value}
				todayButton='Go to current month'
				toMonth={disabledDays?.after ?? null}
				onDayClick={this.handleDayClick}
			/>
		);
	}
}
